












































export default {
    name: 'ArticlePreview'

    props: ['document']

    methods:
        openLightbox: ->
            UIkit.lightbox(@$refs.lightbox).show()
}
